import {type RoomChatResponse, type RoomChatSendFailReason} from '@colonist/protocol-lobby'
import {type TranslationObject} from '@colonist/i18n'

export function convertFailedToSendReasonToChatData(reason: RoomChatSendFailReason, mutedUntil: string | undefined): TranslationObject {
    switch(reason) {
        case 'unableToSend':
            return {key: 'strings:game.gameState.gameLogs.couldNotsendChatMessage'}
        case 'disabled':
            return {key: 'strings:game.gameState.gameLogs.chatIsDisabled'}
        case 'badLanguage':
            return {key: 'strings:game.gameState.gameLogs.useProperLanguage'}
        case 'tooLong':
            return {key: 'strings:game.gameState.gameLogs.messageTooLong'}
        case 'spam':
            return {key: 'strings:game.gameState.gameLogs.pleaseDoNotSpam'}
        case 'wrongCommand':
            return {key: 'strings:commands.errors.wrongCommand'}
        case 'commandCrashed':
            return {key: 'strings:commands.errors.commandCrashed'}
        case 'muted':
            return {key: 'strings:game.gameState.gameLogs.youHaveBeenMuted', options: {date: mutedUntil}}
        case 'notSignedIn':
            return {key: 'strings:game.gameState.gameLogs.signInToAccessChat'}
    }
}

export function convertChatResponseToText(reason: RoomChatResponse): TranslationObject[] {
    switch(reason) {
        case 'tutorial':
            const exampleResources = `"lumbér/bríck"`
            const exampleItems = 'lumberbricksheepgrain ore:road:settlementcity'
            const emojiTutorial: TranslationObject = {key: 'strings:commands.messages.emojiTutorial', options: {
                exampleString: exampleResources,
                exampleEmojis: exampleItems,
            }}
            const exampleCommand = `"/disablechat"`
            const chatTutorial: TranslationObject = {key: 'strings:commands.messages.chatTutorial', options: {
                exampleString: exampleCommand,
            }}
            return [emojiTutorial, chatTutorial]
        case 'chatEnabled':
            return [{key: 'strings:commands.messages.chatEnabled'}]
        case 'chatDisabled':
            return [{key: 'strings:commands.messages.chatDisabled'}]
    }
}
